import { EmptyState } from '../components/EmptyState.js';

export function NotFound({ path }: { path: string }) {
  return (
    <EmptyState
      title="Page not found"
      body={`No route matches ${path}. It may be a Phase 2+ surface that hasn't shipped yet.`}
    />
  );
}
